import { BaseRouteService } from "core/services";

class FacilityInventoryCalculationItemRouteService extends BaseRouteService {
	constructor() {
		super("facility-inventory-calculation-items");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,facilityInventoryCalculationId}`, filter);
	}	
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}	
	
	delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }
	
	validateQuantity(id,inventoryCalculationCutbacksQuantity){
        return super.get(this.base + '/validate-quantity/{id}/{inventoryCalculationCutbacksQuantity}', null, {
            id: id,
			inventoryCalculationCutbacksQuantity: inventoryCalculationCutbacksQuantity
        })
    }
	
	updateActualCutbackExtraSuppliesQuantity(resource){
        return super.update(this.base + '/update-actual-cutback-extra-supplies-quantity/{id}/{actualQuantity}', resource)
    }
}

export default FacilityInventoryCalculationItemRouteService;